<script>
export default {
    name: "ConstructionInternalInfoTab",
    props: {
        construction: {required: true},
        shows: {required: false, default: []},
    }
}
</script>

<template>
    <div>
        <div class="row">
            <div class="col-xg-6 col-lg-6 col-xs-12">
                <div class="portlet light-grey" style="height: 110px; max-height: 110px; overflow-y: auto;margin-bottom:15px">
                    <strong>Obs. Internas: </strong>
                    <a href="javascript:;" class="btn btn-xs blue"
                       @click="$emit('shows', 'internal_notes')" v-if="construction.notes">
                        <span v-if="!shows['internal_notes']">Exibir</span>
                        <span v-if="shows['internal_notes']">Ocultar</span>
                    </a>
                    <span v-if="shows['internal_notes']">{{ construction.notes }}</span>
                    <span v-if="!construction.notes">-</span>
                </div>
            </div>
            <div class="col-xg-6 col-lg-6 col-xs-12">
                <div class="portlet light-grey" style="height: 110px; max-height: 110px; overflow-y: auto;margin-bottom:15px">
                    <p>
                        <strong>Obs. do Site:</strong>
                        <span v-if="construction.website_notes">{{ construction.website_notes }}</span>
                        <span v-else>-</span>
                    </p>
                    <p>

                    </p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xg-6 col-lg-6 col-xs-12"  v-el:customers>
                <div class="portlet light" style="margin-bottom:15px">
                    <div>
                        <strong>Proprietário(s): </strong>
                        <div v-if="! construction.can.view_owners">
                            Sem informações ou você não possui permissão.
                        </div>
                        <div v-else>
                            <a href="javascript:;" class="btn btn-xs blue"
                               @click="$emit('shows', 'owners')" v-if="construction.owners.length > 0">
                                <span v-if="!shows['owners']">Exibir</span>
                                <span v-if="shows['owners']">Ocultar</span>
                            </a>
                            <span v-if="construction.owners.length == 0">-</span>
                            <table class="table table-bordered table-hovered table-striped table-responsive" v-if="shows['owners']" style="margin-top: 20px;">
                                <thead>
                                <th>Nome</th>
                                <th>Telefone</th>
                                <th>Email</th>
                                <th></th>
                                </thead>
                                <tbody>
                                <tr v-for="owner in construction.owners">
                                    <td>{{ owner.name }}</td>
                                    <td v-if=" owner.phone">{{ owner.phone | phone }}</td>
                                    <td v-else>-</td>
                                    <td>{{ owner.email }}</td>
                                    <!-- <td><a :href="'/customers/' + owner.id" :disabled="info.can_edit_owners" target="_blank" title="Ver mais informações" v-tooltip><i class="fa fa-eye"></i></a></td> -->
                                    <td><a @click.prevent="showCustomer(owner)" :disabled="info.can_edit_owners" target="_blank" title="Ver mais informações" v-tooltip><i class="fa fa-eye"></i></a></td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xg-6 col-lg-6 col-xs-12">
                <div class="portlet light" style="margin-bottom:15px">
                    <div class="row">
                        <div class="col-xg-6 col-lg-6 col-xs-12">
                            <strong>Autorização de venda</strong>
                            <p>{{ construction.authorization_start_date | date }} - {{ construction.authorization_end_date | date }}</p>
                        </div>
                        <div class="col-xg-6 col-lg-6 col-xs-12">
                            <strong>Exclusividade de venda</strong>
                            <p>{{ construction.exclusivity_start_date | date }} - {{ construction.exclusivity_end_date | date }}</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xg-6 col-lg-6 col-xs-12">
                            <strong>Autorização de locação</strong>
                            <p>{{ construction.rent_authorization_start_date | date }} - {{ construction.rent_authorization_end_date | date }}</p>
                        </div>
                        <div class="col-xg-6 col-lg-6 col-xs-12">
                            <strong>Exclusividade de locação</strong>
                            <p>{{ construction.rent_exclusivity_start_date | date }} - {{ construction.rent_exclusivity_end_date | date }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-6">
                <div class="portlet light-grey" style="width: 100%;float: left;">
                    <div class="pull-left" style="margin-right: 30px;">
                        <strong>Captador: </strong>
                        <span v-if="construction.receiver1">{{ construction.receiver1.name }}</span>
                        <span v-else>-</span>
                    </div>
                    <div class="pull-left">
                        <strong>Captador: </strong>
                        <span v-if="construction.receiver2">{{ construction.receiver2.name }}</span>
                        <span v-else>-</span>
                    </div>
                </div>
            </div>
            <div class="col-xs-6">
                <div class="portlet light-grey" style="width: 100%;float: left;">
                    <div class="pull-left" style="margin-right: 30px;">
                        <strong>Indicador: </strong>
                        <span v-if="construction.indicator1">{{ construction.indicator1 }}</span>
                        <span v-else>-</span>
                    </div>
                    <div class="pull-left">
                        <strong>Indicador: </strong>
                        <span v-if="construction.indicator2">{{ construction.indicator2 }}</span>
                        <span v-else>-</span>
                    </div>

                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-6">
                <div class="portlet light" style="padding-bottom: 0;margin-bottom: 0;">
                    <div class="row">
                        <div class="col-xs-12">
                            <p>
                                <strong style="width: 71px;display: inline-block;">Cartório: </strong>
                                <a href="javascript:;" class="btn btn-xs blue"
                                   @click="$emit('shows', 'registry')">
                                    <span v-if="!shows['registry']">Exibir</span>
                                    <span v-if="shows['registry']">Ocultar</span>
                                </a>
                                <span v-if="!construction.registry">-</span>
                                <span v-if="shows['registry']">{{ construction.registry }}</span>
                            </p>
                        </div>
                        <div class="col-xs-12">
                            <p>
                                <strong style="width: 71px;display: inline-block;">Escritura: </strong>
                                <a href="javascript:;" class="btn btn-xs blue"
                                   @click="$emit('shows', 'deed')" v-if="construction.deed_status">
                                    <span v-if="!shows['deed']">Exibir</span>
                                    <span v-if="shows['deed']">Ocultar</span>
                                </a>
                                <span v-if="!construction.deed_status">-</span>
                                <span v-if="shows['deed']">{{ construction.deed_status }}</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xs-6">
                <div class="portlet light" style="padding-bottom: 0;margin-bottom: 0;">
                    <div class="row">
                        <div class="col-xs-6">
                            <p>
                                <strong style="width: 80px;display: inline-block;">Matrícula: </strong>
                                <a href="javascript:;" class="btn btn-xs blue"
                                   @click="$emit('shows', 'registration_number')" v-if="construction.registration_number">
                                    <span v-if="!shows['registration_number']">Exibir</span>
                                    <span v-if="shows['registration_number']">Ocultar</span>
                                </a>
                                <span v-if="!construction.registration_number">-</span>
                                <span v-if="shows['registration_number']">{{ construction.registration_number }}</span>
                            </p>
                        </div>
                        <div class="col-xs-6">
                            <p>
                                <strong style="width: 45px;display: inline-block;">Água: </strong>
                                <a href="javascript:;" class="btn btn-xs blue"
                                   @click="$emit('shows', 'water')" v-if="construction.water_number">
                                    <span v-if="!shows['water']">Exibir</span>
                                    <span v-if="shows['water']">Ocultar</span>
                                </a>
                                <span v-if="!construction.water_number">-</span>
                                <span v-if="shows['water']">{{ construction.water_number }}</span>

                            </p>
                        </div>
                        <div class="col-xs-6">
                            <p>
                                <strong style="width: 80px;display: inline-block;">Energia: </strong>
                                <a href="javascript:;" class="btn btn-xs blue"
                                   @click="$emit('shows', 'energy')" v-if="construction.energy_number">
                                    <span v-if="!shows['energy']">Exibir</span>
                                    <span v-if="shows['energy']">Ocultar</span>
                                </a>
                                <span v-if="!construction.energy_number">-</span>
                                <span v-if="shows['energy']">{{ construction.energy_number }}</span>
                            </p>
                        </div>
                        <div class="col-xs-6">
                            <p>
                                <strong style="width: 45px;display: inline-block;">IPTU: </strong>
                                <a href="javascript:;" class="btn btn-xs blue"
                                   @click="$emit('shows', 'iptu')" v-if="construction.iptu_number">
                                    <span v-if="!shows['iptu']">Exibir</span>
                                    <span v-if="shows['iptu']">Ocultar</span>
                                </a>
                                <span v-if="!construction.iptu_number">-</span>
                                <span v-if="shows['iptu']">{{ construction.iptu_number }}</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>


// WEBPACK FOOTER //
// ConstructionInternalInfoTab.vue?54b11b3b